import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-140b9410"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "top" }),
  /*#__PURE__*/_createElementVNode("div", { class: "bottom" })
], -1))
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "data-cont innerContainer" }
const _hoisted_5 = { class: "box" }
const _hoisted_6 = { class: "ttl uppercase luxury" }
const _hoisted_7 = { class: "desc fira" }
const _hoisted_8 = { class: "box" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["innerHTML"]

import { computed, ref, onMounted, watch } from "vue";
import type { Ref, ComputedRef } from "vue";
import { get, includes } from "lodash";
import { useMenuStore } from "@/store/pinia/menu";
import { isInViewport } from "@/composables/mobileWatcher";

// Define store

export default /*#__PURE__*/_defineComponent({
  props: {
    contentData: {
        type: Object,
    },
},
  setup(__props) {

const props = __props

/**
 * @author Tornike Jortmenadze (Jortsoft)
 */

const store = useMenuStore();

// Define global variables
const mobileClass: Ref<Boolean> = ref(false);

// Define props


// Define reactive data
const locoScrollY = computed(() => store.locoScrollY);
const isDarkBody = computed(() => store.isDark);
const getData: ComputedRef<object> = computed(() => {
    return get(props, "contentData.data.list.0");
});
const getCompany: ComputedRef<object> = computed(() => {
    if (get(getData.value, "partners.length") > 0) {
        return get(store, "indx.terms.partners").filter((el: any) =>
            includes(get(getData.value, "partners"), el.id)
        );
    }
    return get(store, "indx.terms.partners");
});

watch(locoScrollY, () => {
    if (isInViewport(document.querySelector(".partners .par"))) {
        mobileClass.value = true;
    }
});

// Custom functions
const mobileScroll = (): void => {
    document.getElementById("app").addEventListener("scroll", () => {
        if (isInViewport(document.querySelector(".partners .par"))) {
            mobileClass.value = true;
        }
    });
};
const pageLink = (url: string): void => {
    if (url === "") return;
    window.location = url;
};

// Function expression
onMounted(() => {
    if (window.innerWidth < 1024) {
        mobileScroll();
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["partners", {
        'is-inview': mobileClass.value,
        dark: _unref(store).isBgDark || _unref(includes)(_unref(get)(__props.contentData, 'conf.conf'), 'dark'),
        dark2: _unref(isDarkBody),
    }]),
    "data-scroll": ""
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("img", {
        class: "bg",
        "data-scroll": "",
        "data-scroll-speed": "-2",
        src: _ctx.$get(_unref(getData), 'images.0.devices.desktop')
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$get(_unref(getData), "title")), 1),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$get(_unref(getData), "teaser")), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getCompany), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["par", { pointer: item?.link !== '' }]),
              key: index,
              style: _normalizeStyle(`transition-delay: ${index / 5}s`),
              onClick: ($event: any) => (pageLink(_ctx.$get(item, 'link')))
            }, [
              _createElementVNode("div", {
                class: "icon",
                innerHTML: _ctx.$get(item, 'logo.logo')
              }, null, 8, _hoisted_10)
            ], 14, _hoisted_9))
          }), 128))
        ])
      ])
    ])
  ], 2))
}
}

})